import { User } from "lucide-react";
import React, { useState } from "react";

export const Avatar = ({
	src,
	alt = "User avatar",
	size = "md",
	className = "",
}) => {
	// Set imageError to false initially
	const [imageError, setImageError] = useState(false);

	const sizeClasses = {
		sm: "w-4 h-4",
		md: "w-6 h-6",
		lg: "w-8 h-8",
	};

	const iconSizeClasses = {
		sm: "w-2 h-2",
		md: "w-3 h-3",
		lg: "w-4 h-4",
	};

	const initialsSizeClasses = {
		sm: "text-[8px]",
		md: "text-[9px]",
		lg: "text-[11px]",
	};

	// Extract initials from alt text (user name)
	const getInitials = (name) => {
		if (!name || name === "User avatar" || name === "Unknown Author")
			return "?";
		return name
			.split(" ")
			.map((word) => word.charAt(0).toUpperCase())
			.slice(0, 2)
			.join("");
	};

	// If no src or image failed to load, show fallback
	if (!src || imageError) {
		const initials = getInitials(alt);

		return (
			<div
				className={`rounded-full flex-shrink-0 ${sizeClasses[size]} ${className} bg-[var(--color-bg-secondary)] border border-[var(--color-border)] flex items-center justify-center`}
			>
				{initials !== "?" ? (
					<span
						className={`${initialsSizeClasses[size] || initialsSizeClasses.sm} font-medium text-[var(--color-text-primary)]`}
					>
						{initials}
					</span>
				) : (
					<User
						className={`${iconSizeClasses[size]} text-[var(--color-text-secondary)]`}
					/>
				)}
			</div>
		);
	}

	return (
		<img
			src={src}
			alt={alt}
			className={`rounded-full flex-shrink-0 ${sizeClasses[size]} ${className}`}
			loading="lazy"
			referrerPolicy="no-referrer"
			onError={() => setImageError(true)}
		/>
	);
};
